import { createFileRoute } from '@tanstack/react-router'
import { Header } from '@/components/Header'
import { Footer } from '@/components/Footer'
import { LegalDocument } from '@/features/legal/components/LegalDocument'
import {
  TERMS_TOC,
  TermsContent,
} from '@/features/legal/components/TermsContent'
import { PageHero } from '@/shared/components/marketing/PageHero'
import { generateLinks, generateMetaTags, routeSEO } from '@/lib/seo'

export const Route = createFileRoute('/terms')({
  head: () => ({
    meta: generateMetaTags(routeSEO['/terms']),
    links: generateLinks(routeSEO['/terms']),
  }),
  component: TermsPage,
})

function TermsPage() {
  return (
    <div className="relative flex min-h-screen flex-col overflow-x-clip bg-[var(--color-bg-primary)]">
      <Header />

      <main className="flex-1">
        <PageHero
          eyebrow="Legal"
          title="Terms of service"
          lede="Last updated: February 5, 2026"
        />
        <LegalDocument toc={TERMS_TOC}>
          <TermsContent />
        </LegalDocument>
      </main>

      <Footer />
    </div>
  )
}
